
<div class="creative-people-area bg_image--50 ptb--200 ptb-md--80 ptb-sm--80">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="creative-people-inner text-center">
                    <h2 class="heading">Neuro Akashico<sup>®</sup><span class="theme-color"> Gran Sistema de Redes</span></h2>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Info del curso -->
<div class="bk-number-speaks section-ptb-xl bg_image--3">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12">
                <div class="number-speaks">
                    <div class="content wow move-up">
                        <h3 class="theme-color">Nuestro Objetivo</h3>
                        <h2>TRANSMITE <br> <span class="secondary-color">PRACTICA</span> Y ENSEÑA</h2>
                        <div class=""> <img src="assets/img/neuroakashico.png" alt="Brook Preloader"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12 mt_md--40 mt_sm--40">
                <div class="speakers-number-wrap">

                    <!-- Start Single Count -->
                    <div class="number-wrap wow move-up">
                        <span class=" theme-color">$3,333</span>
                        <div class="content">
                            <h6>Precio para practicantes</h6>
                            <p>La formación para practicantes es ideal para el desarrollo de la consciencia y el desarrollo personal. Te permite crecer en todos los ambitos de tu vida.</p><br> <a class="bk-btn theme-btn" href="#">Inscribirme</a>
                        </div>
                    </div>
                    <!-- End Single Count -->

                    <!-- Start Single Count -->
                    <div class="number-wrap mt--70 wow move-up">
                        <span class="theme-color">$9,000</span>
                        <div class="content">
                            <h6>Precio para facilitadores</h6>
                            <p>En cambio los facilitadores son preparados para capacitar y enseñar a otros. Adquieren todas las herramientas que proporciona nuestra escuela.</p>
                            <br> <a class="bk-btn theme-btn" href="#">Inscribirme</a>
                        </div>
                    </div>
                    <!-- End Single Count -->
                </div>
            </div>
        </div>
    </div>
</div>
